import { render, staticRenderFns } from "./iconSelect.vue?vue&type=template&id=528eebfb"
import script from "./iconSelect.vue?vue&type=script&lang=js"
export * from "./iconSelect.vue?vue&type=script&lang=js"
import style0 from "./iconSelect.vue?vue&type=style&index=0&id=528eebfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports